import { formatTimespan } from 'rev-shared/date/DateFormatters';

import { ISubtitle } from '@vbrick/vbrick-player/app/player/ISubtitle';


export function formatSrt(entries: ISubtitle[]): string {
	return entries
		.map((entry, i) => formatSrtEntry(i + 1, entry))
		.join('\n\n') + '\n';
}

function formatSrtEntry(counter: number, entry: ISubtitle): string {
	return [
		'' + counter,
		`${formatTime(entry.start)} --> ${formatTime(entry.end)}`,
		entry.text.trim()
	].join('\n');
}

function formatTime(time: number): string {
	return formatTimespan(time * 1000, {
		decimalSeparator: ',',
		includeMilliseconds: true,
		noDays: true,
		padFields: true
	});
}
